import CloseIcon from '@mui/icons-material/Close';
import {
  IconButton, List, ListItem, MenuItem, Select, Stack, Typography
} from '@mui/material';
import { FC, memo } from 'react';
import { RuleFile } from 'src/entities/import';

// 先方のファイル名は濁点が分離した NFD で届くことがあるので、名前で照合する前に揃える
export const matchRuleFile = (fileName: string, ruleFiles: RuleFile[]): RuleFile | undefined => (
  ruleFiles.find((ruleFile) => new RegExp(ruleFile.pattern).test(fileName.normalize('NFC')))
);

// 落としたファイルがどの種別として読まれるかを出す。名前の規則から外れたファイルは
// 種別を選んでもらい、file_kinds として API へ送る（設計書 #405）
const RuleFileList: FC<{
  files: File[];
  ruleFiles: RuleFile[];
  fileKinds: Record<string, string>;
  onChangeKind: (fileName: string, kind: string) => void;
  onRemove: (fileName: string) => void;
}> = memo(({
  files, ruleFiles, fileKinds, onChangeKind, onRemove
}) => (
  <List dense>
    {files.map((file) => {
      const matched = matchRuleFile(file.name, ruleFiles);

      return (
        <ListItem
          key={file.name}
          secondaryAction={(
            <IconButton edge="end" aria-label={`${file.name} を外す`} onClick={() => onRemove(file.name)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        >
          <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
            <Typography variant="body2" sx={{ flexGrow: 1, wordBreak: 'break-all' }}>
              {file.name}
            </Typography>
            {matched ? (
              <Typography variant="body2" color="text.secondary">{matched.label}</Typography>
            ) : (
              <Select
                size="small"
                displayEmpty
                sx={{ minWidth: 200 }}
                value={fileKinds[file.name] ?? ''}
                onChange={(event) => onChangeKind(file.name, event.target.value)}
              >
                <MenuItem value="">種別を選んでください</MenuItem>
                {ruleFiles.map((ruleFile) => (
                  <MenuItem key={ruleFile.name} value={ruleFile.name}>{ruleFile.label}</MenuItem>
                ))}
              </Select>
            )}
          </Stack>
        </ListItem>
      );
    })}
  </List>
));

export default RuleFileList;
